export default __webpack_public_path__ + "static/media/image@2x.3ae86baa.jpg";